import React, {useEffect, useState} from 'react'
import {Button, Form, message, Modal, Popconfirm, Select, Tag} from "antd"
import {searchTenant} from "../../../../../../services/api/apiUser"
import {transferShortPhone} from "../../../../../../services/api/apiCustomerHub"
import parseToken from "../../../../../../helpers/parseToken"
import {SwapOutlined, ExclamationCircleOutlined} from "@ant-design/icons"

const TransferShortPhoneModal = (props) => {
    const {visible, onClose, shortPhone, onGetAgain} = props
    const [formTransfer] = Form.useForm()
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)
    const [tenants, setTenants] = useState([])
    const [isConfirmStep, setIsConfirmStep] = useState(false)
    const [confirmData, setConfirmData] = useState(null)

    const _fetchListTenant = async () => {
        try {
            const payload = {
                page: 1,
                limit: 10000
            }
            const response = await searchTenant(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => {
                return {
                    label: item.name,
                    name: item.name,
                    value: item.id,
                }
            })

            setTenants(_tenants)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onTransfer = async () => {
        setLoading(true)
        try {
            const payload = {
                tenantId: parseInt(confirmData.tenantId),
                tenantName: confirmData.tenantName,
                shortPhone: shortPhone
            }

            const response = await transferShortPhone(decodeToken.sub, payload)
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }

            setLoading(false)
            message.success('Chuyển cụm thành công!')
            handleClose()
            onGetAgain()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const handleSubmitForm = () => {
        const getValues = formTransfer.getFieldsValue()
        setConfirmData({
            tenantId: getValues.tenantId?.value,
            tenantName: getValues.tenantId?.label,
        })
        setIsConfirmStep(true)
    }

    const handleBackToForm = () => {
        setIsConfirmStep(false)
        setConfirmData(null)
    }

    const handleClose = () => {
        formTransfer.resetFields()
        setIsConfirmStep(false)
        setConfirmData(null)
        onClose()
    }

    useEffect(() => {
        if (visible) {
            _fetchListTenant()
        }
        // eslint-disable-next-line
    }, [visible])

    return (
        <Modal
            className='ModalCustom2'
            maskClosable={false}
            open={visible}
            title={
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <SwapOutlined style={{fontSize: '22px', color: '#506CDF'}}/>
                    <span>{isConfirmStep ? 'Xác nhận chuyển cụm' : 'Chuyển cụm'}</span>
                </div>
            }
            footer={isConfirmStep ? [
                <div className="Actions d-flex justify-content-end align-items-center" key="confirm-actions">
                    <Button key="back" type="link" onClick={handleBackToForm} disabled={loading}>
                        Quay lại
                    </Button>
                    <Button key="submit" type="primary" onClick={_onTransfer} loading={loading}>
                        Xác nhận chuyển cụm
                    </Button>
                </div>
            ] : [
                <div className="Actions d-flex justify-content-end align-items-center" key="form-actions">
                    <Popconfirm placement="top" title="Bạn chắc chắn muốn thoát?" onConfirm={handleClose} okText="Yes"
                                cancelText="No">
                        <Button key="back" type="link" disabled={loading}>
                            Cancel
                        </Button>
                    </Popconfirm>
                    <Button key="submit" type="primary" htmlType='submit' form='formTransferShortPhone'
                            loading={loading}>
                        Tiếp tục
                    </Button>
                </div>
            ]}
        >
            {!isConfirmStep ? (
                <Form
                    layout="vertical"
                    className='FormEdit'
                    form={formTransfer}
                    id='formTransferShortPhone'
                    onFinish={handleSubmitForm}
                >
                    <div style={{
                        background: '#F0F5FF',
                        borderRadius: '6px',
                        padding: '12px 16px',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <span style={{color: '#596680', fontSize: '14px'}}>Số ảo:</span>
                        <Tag color="blue" style={{fontSize: '14px', margin: 0, fontWeight: 600}}>{shortPhone}</Tag>
                    </div>

                    <Form.Item
                        className='FormField'
                        label={<label className="Label">Cụm khách hàng<span className="Required">*</span></label>}
                        name="tenantId"
                        rules={[
                            {
                                required: true,
                                message: 'Bắt buộc chọn cụm khách hàng'
                            }
                        ]}
                    >
                        <Select
                            labelInValue
                            showSearch
                            allowClear
                            style={{width: '100%'}}
                            placeholder={"Tìm và chọn cụm khách hàng"}
                            filterOption={(input, option) => (option.children).toLowerCase().includes(input.toLowerCase())}
                        >
                            {
                                tenants && tenants?.length > 0 && tenants.map((item, index) => {
                                    return <Select.Option
                                        value={item.value}
                                        key={item.value + '_' + index}
                                    >
                                        {item.label}
                                    </Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                </Form>
            ) : (
                <div style={{padding: '8px 0'}}>
                    <div style={{
                        background: '#FFFBE6',
                        border: '1px solid #FFE58F',
                        borderRadius: '6px',
                        padding: '14px 16px',
                        marginBottom: '24px',
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '10px'
                    }}>
                        <ExclamationCircleOutlined style={{color: '#FAAD14', fontSize: '18px', marginTop: '2px'}}/>
                        <span style={{color: '#595959', fontSize: '14px', lineHeight: '22px'}}>
                            Vui lòng kiểm tra lại thông tin trước khi xác nhận chuyển cụm.
                        </span>
                    </div>

                    <div style={{
                        background: '#FAFAFA',
                        borderRadius: '8px',
                        padding: '20px',
                        border: '1px solid #F0F0F0'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '16px',
                            paddingBottom: '16px',
                            borderBottom: '1px dashed #E8E8E8'
                        }}>
                            <span style={{color: '#8C8C8C', fontSize: '14px'}}>Số ảo</span>
                            <Tag color="blue" style={{fontSize: '14px', margin: 0, fontWeight: 600}}>
                                {shortPhone}
                            </Tag>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                            <span style={{color: '#8C8C8C', fontSize: '14px'}}>Cụm đích</span>
                            <span style={{
                                color: '#032D60',
                                fontSize: '14px',
                                fontWeight: 600
                            }}>{confirmData?.tenantName}</span>
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default TransferShortPhoneModal
